import { render, staticRenderFns } from "./dialog-radio.vue?vue&type=template&id=5bfcf950&scoped=true"
import script from "./dialog-radio.vue?vue&type=script&lang=js"
export * from "./dialog-radio.vue?vue&type=script&lang=js"
import style0 from "./dialog-radio.vue?vue&type=style&index=0&id=5bfcf950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfcf950",
  null
  
)

export default component.exports